import React from 'react'
import Slide from './Slide'
import Transition from 'react-transition-group/Transition'
import Disclaimer from './Disclaimer'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Modal, ModalBody, Button, ModalHeader } from 'reactstrap'
import './SplitSlide.css'
import './SplitSlideStory.css'
import 'bootstrap/dist/css/bootstrap.min.css';

class SplitSlideStory extends Slide {
    
    constructor(props) {
        super(props)
        this.state = { 
            modal: false
        }
        this.toggleModal = this.toggleModal.bind(this)
    }


    toggleModal() {
        this.setState({ modal: !this.state.modal })
    }

    renderMobile() {

        const defaultStyles = (duration, delay = 300) => ({
            transition: `opacity ${duration}ms ${delay}ms ease-in`
        })

        const transitionStyles = {
            entering: { opacity: 0 },
            entered: { opacity: 1 },
            exiting: { opacity: 1 },
            exited: { opacity: 0 }
        }

        return super.render(
            <Transition in={this.props.in} timeout={0}>
                { state => (
                    <div className='SplitSlide' style={{background: `url(${this.props.background})`}}>
                        <div className='SplitSlide-Title' style={{...defaultStyles(300, 1000), ...transitionStyles[state]}}>
                            { this.props.title }
                        </div>
                        <div className='SplitSlide-Info-Mobile'>
                            <Button color='primary' onClick={this.toggleModal} className='SplitSlideStory-Button'><div>...</div></Button>
                            <Modal isOpen={this.state.modal} toggle={this.toggleModal}>
                                <ModalHeader toggle={this.toggleModal} charCode='X'>{this.props.title}</ModalHeader>
                                <ModalBody>
                                    <div className='SplitSlideStory-Text-Mobile'>{ this.props.story.text }</div>
                                    <div className='SplitSlideStory-Caption-Mobile' >{ this.props.story.caption }</div>
                                    { this.props.story.desc &&
                                        <React.Fragment>
                                            <div className='SplitSlide-Desc' style={{...defaultStyles(300, 2000), ...transitionStyles[state]}}>
                                                <span><b>{ this.props.story.desc.caption }</b></span>
                                                <br/>
                                                <span>{ this.props.story.desc.text }</span>
                                                <br/>
                                                <span><i>{ this.props.story.desc.location }</i></span>
                                            </div>
                                        </React.Fragment>  
                                    }
                                </ModalBody>  
                            </Modal>
                            { this.props.desc && 
                                <div className='SplitSlide-Desc' style={{...defaultStyles(300, 2000), ...transitionStyles[state]}}>
                                    <span><b>{ this.props.desc.caption }</b></span>
                                    <br/>
                                    <span>{ this.props.desc.text }</span>
                                    <br/>
                                    <span><i>{ this.props.desc.location }</i></span>
                                </div>
                            }
                        </div>
                    </div>
                )}
            </Transition>
        )

    }



    render() {

        if(this.props.isMobile) return this.renderMobile()

        const defaultStyles = (duration, delay = 300) => ({
            transition: `opacity ${duration}ms ${delay}ms ease-in`
        })

        const transitionStyles = {
            entering: { opacity: 0 },
            entered: { opacity: 1 },
            exiting: { opacity: 1 },
            exited: { opacity: 0 }
        }

        return super.render(
            <Transition in={this.props.in} timeout={0}>
                { state => (
                    <div className='SplitSlide' style={{background: `url(${this.props.background})`}}>
                        <div className='SplitSlide-Title' style={{...defaultStyles(300, 1000), ...transitionStyles[state]}}>
                            { this.props.title }
                        </div>
                        <div className='SplitSlide-Info'>
                            <Disclaimer className='SplitSlide-Disclaimer' style={{...defaultStyles(300, 3000), ...transitionStyles[state]}}/>
                            <Button color='primary' onClick={this.toggleModal} className='SplitSlideStory-Button'><div>...</div></Button>
                            <Modal isOpen={this.state.modal} toggle={this.toggleModal}>
                                <ModalHeader toggle={this.toggleModal} charCode='X'>{this.props.title}</ModalHeader>
                                <ModalBody>
                                    <div className='SplitSlideStory-Text'>{ this.props.story.text }</div>
                                    <div className='SplitSlideStory-Caption' >{ this.props.story.caption }</div>
                                    { this.props.story.desc &&
                                        <React.Fragment>
                                            <div className='SplitSlide-Desc' style={{...defaultStyles(300, 2000), ...transitionStyles[state]}}>
                                                <span><b>{ this.props.story.desc.caption }</b></span>
                                                <br/>
                                                <span>{ this.props.story.desc.text }</span>
                                                <br/>
                                                <span><i>{ this.props.story.desc.location }</i></span>
                                            </div>
                                        </React.Fragment>  
                                    }
                                </ModalBody>  
                            </Modal>
                            { this.props.desc && 
                                <div className='SplitSlide-Desc' style={{...defaultStyles(300, 2000), ...transitionStyles[state]}}>
                                    <span><b>{ this.props.desc.caption }</b></span>
                                    <br/>
                                    <span>{ this.props.desc.text }</span>
                                    <br/>
                                    <span><i>{ this.props.desc.location }</i></span>
                                </div>
                            }
                        </div>
                    </div>
                )}
            </Transition>
        )
    }
}

SplitSlideStory.propTypes = {
    title: PropTypes.any.isRequired,
    background: PropTypes.string.isRequired,
    desc: PropTypes.any,
    story: PropTypes.object.isRequired,
    isMobile: PropTypes.bool.isRequired
}

const mapStateToProps = ({ isMobile }) => ({ isMobile })

export default connect(mapStateToProps)(SplitSlideStory)


// WEBPACK FOOTER //
// ./src/components/SplitSlideStory.js